module.exports = __webpack_public_path__ + "static/media/brush-outline.17bd1d26.png";